export default {
  title: '{type} migracja stan',
  resetMessage: 'Czy na pewno chcesz zresetować status migracji dla {count} {type}?\nW rezultacie wszystkie {type} zostaną zmigrowane z pierwszych dostępnych danych na PT9800.',
};
